export default "__VITE_ASSET__CSHOu4wE__"